var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10.865c.152-.153.355-.153.5 0l1.5 1.575c.257.265.75.788.75 1.444 0 .788-.563 1.444-1.375 1.444a1.45 1.45 0 01-.529-.105l.364 1.527H8.044l.36-1.513a1.491 1.491 0 01-.53.091c-.812 0-1.374-.656-1.374-1.444 0-.64.468-1.148.71-1.411l.025-.025c.011-.012 1.361-1.43 1.515-1.583z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.92 5.208a1 1 0 01.898.995V21l-.005.103a1 1 0 01-.893.892l-.102.005H4.27l-.102-.005a1.001 1.001 0 01-.893-.892L3.27 21V6.203a1 1 0 011-1h9.548l.103.005zM4.77 20.5h8.548V6.703H4.77V20.5z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.721 2.494a1 1 0 011.225-.707l9.223 2.472a1 1 0 01.706 1.225l-3.83 14.293a1 1 0 01-1.224.707l-.019-.005V5.154a1 1 0 00-1-1H9.277l.444-1.66z",
    fill: "currentColor"
  })));
}
SvgPoker.displayName = 'Poker';
export default SvgPoker;